import { Box, Button, Typography } from "@mui/material";
import errorBoundary from "../assets/images/error_boundary.png";

const ErrorFallBack = ({ error, resetErrorBoundary, children }: any) => {
  return (
    <>
      {error ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"90vh"}
        >
          <Box textAlign={"center"}>
            <img width="700px" alt="error-boundary" src={errorBoundary} />
            <Typography variant="h5" sx={{ mt: 2 }} fontWeight={"bold"}>
              Oops! something went wrong
            </Typography>
            {typeof error === "object" && (
              <Typography variant="subtitle1" fontWeight={400}>
                <pre style={{ color: "red" }}>{error?.message}</pre>
              </Typography>
            )}
            {typeof error === "string" && (
              <Typography variant="subtitle1" fontWeight={400}>
                <pre style={{ color: "red" }}>{error}</pre>
              </Typography>
            )}
            <Button
              onClick={resetErrorBoundary}
              sx={{ mt: 3 }}
              variant="contained"
            >
              Refresh
            </Button>
          </Box>
        </Box>
      ) : (
        children
      )}
    </>
  );
};

export default ErrorFallBack;
